module.exports = __webpack_public_path__ + "img/06186733002435.cf28e836.png";